// extracted by mini-css-extract-plugin
export default {"button":"Link_button__yJbvI"};